/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Pipelines_Pipeline_Has_ItemsInputs */

const cs_pipelines_pipeline_has_items = /** @type {(inputs: Pipelines_Pipeline_Has_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tato pipeline obsahuje ${i?.count} položek. Vyberte jinou pipeline a namapujte každou obsazenou fázi.`)
};

const en_pipelines_pipeline_has_items = /** @type {(inputs: Pipelines_Pipeline_Has_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This pipeline has ${i?.count} items. Choose another pipeline and map every occupied stage.`)
};

/**
* | output |
* | --- |
* | "This pipeline has {count} items. Choose another pipeline and map every occupied stage." |
*
* @param {Pipelines_Pipeline_Has_ItemsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_pipeline_has_items = /** @type {((inputs: Pipelines_Pipeline_Has_ItemsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Pipeline_Has_ItemsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_pipeline_has_items(inputs)
	return cs_pipelines_pipeline_has_items(inputs)
});